import { render, staticRenderFns } from "./healthy_format.vue?vue&type=template&id=83a21722&scoped=true&"
import script from "./healthy_format.vue?vue&type=script&lang=js&"
export * from "./healthy_format.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83a21722",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/andres/repositories/merge/webapp/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VRadio } from 'vuetify/lib'
import { VRadioGroup } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
installComponents(component, {VAlert,VBtn,VCard,VCardActions,VCardText,VDialog,VDivider,VFlex,VIcon,VLayout,VRadio,VRadioGroup,VSpacer,VToolbar,VToolbarTitle})
